export function getParentURL(url: string): string {
  const current = url.split('?')[0].replace(/\/$/, '');
  const segments = current.split('/');

  if (segments.length > 1) {
    return segments.slice(0, -1).join('/') || '/';
  }
  return current;
}
